/*
 * Copyright (c) 2022-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';


class VehicleBuildOptions {
}

@Injectable({
    providedIn: 'root'
})
export class FileDownloadService {
    capitalComponentUsageDownloadUrl = '/esciUI/capitalComponentUsageDownload/';
    buildCheckToolReportUrl = '/esciUI/buildCheckToolReport';
    ktsTemplateReportByVersionUrl = '/esciUI/ktsTemplateReportByVersion';
    allIcdDatesReportUrl = '/esciUI/allIcdDatesReport';
    allWhaDatesReportUrl = '/esciUI/allWhaDatesReport';
    allMrdDatesReportUrl = '/esciUI/allMrdDatesReport';
    allBatchReleaseDatesReportUrl = '/esciUI/allBatchReleaseDatesReport';
    allEsorDatesReportUrl = '/esciUI/allEsorDatesReport';
    allCombinedDatesReportUrl = '/esciUI/allCombinedDatesReport';
    finishExportFileUrl = '/esciUI/finishExportFile';

    constructor(private http: HttpClient) {
    }

    download(vehicleBuild: Array<VehicleBuildOptions>): Observable<Blob> {
        const headers = {'content-type': 'application/json'};
        const body = JSON.stringify(vehicleBuild);
        return this.http.post(environment.apiUrl + this.buildCheckToolReportUrl, body, {
            'headers': headers,
            responseType: 'blob'
        });
    }

    exportTemplateReport(version: string, type: string) {
        const formData: FormData = new FormData();
        formData.append('version', version);
        formData.append('type', type);
        return this.http.post(environment.apiUrl + this.ktsTemplateReportByVersionUrl,
            formData, {responseType: 'blob'});
    }

    finishExportFile(wbArrayBuffer: BlobPart, ganttTiles?: {columns: number; tiles: Blob[]} | null) {
        const formData: FormData = new FormData();
        formData.append('wbArrayBuffer', new Blob([wbArrayBuffer], {type: 'application/octet-stream'}));
        if (ganttTiles?.tiles?.length) {
            for (const tile of ganttTiles.tiles) {
                formData.append('tiles', tile, 'gantt.png');
            }
            formData.append('tileColumns', String(ganttTiles.columns));
        }
        return this.http.post(environment.apiUrl + this.finishExportFileUrl,
            formData, {responseType: 'blob'});
    }

    exportAllIcdDatesReport(programRunIds: number[]) {
        return this.http.post(environment.apiUrl + this.allIcdDatesReportUrl, programRunIds, {responseType: 'blob'});
    }

    exportAllWhaTiming(programRunIds: number[]) {
        return this.http.post(environment.apiUrl + this.allWhaDatesReportUrl, programRunIds, {responseType: 'blob'});
    }

    exportAllMrdTiming(programRunIds: number[]) {
        return this.http.post(environment.apiUrl + this.allMrdDatesReportUrl, programRunIds, {responseType: 'blob'});
    }

    exportAllBatchReleaseDatesReport(programRunIds: number[]) {
        return this.http.post(environment.apiUrl + this.allBatchReleaseDatesReportUrl, programRunIds, {responseType: 'blob'});
    }

    exportAllEsorDatesReport(programRunIds: number[]) {
        return this.http.post(environment.apiUrl + this.allEsorDatesReportUrl, programRunIds, {responseType: 'blob'});
    }

    exportAllCombinedDatesReport(programRunIds: number[]) {
        return this.http.post(environment.apiUrl + this.allCombinedDatesReportUrl, programRunIds, {responseType: 'blob'});
    }

    exportConfigFile(url: string) {
        return this.http.get(url, {responseType: 'blob'});
    }

    /**
     * Downloads the result ZIP file for a completed Capital job as a {@link Blob}.
     */
    downloadCapitalJobResult(jobId: string): Observable<Blob> {
        return this.http.get(
            `${environment.apiUrl}${this.capitalComponentUsageDownloadUrl}${jobId}`,
            {responseType: 'blob'}
        );
    }
}
